export enum CourseMappingStatus {
  NotMapped = 0,
  Mapped = 1,
}
